import React, { FC, useState } from "react";
import { Button, Form, Input, notification } from "antd";
import CommonService from "../../services/common.service";
import SubscribesService from "../../services/subscribes.service";

const SubscribeForm: FC = () => {
  const [loading, setLoading] = useState(false);

  const subscribe = async (email: string) => {
    setLoading(true);

    try {
      await SubscribesService.subscribe(email);

      notification.success({
        message: `You have been successfully subscribed`,
      });
    } catch (errors) {
      setLoading(false);

      CommonService.showAllErrors(errors);
    }
  };

  const handleSubmitForm = async (values: any) => {
    await subscribe(values?.email);
  };

  return (
    <Form
      layout="inline"
      hideRequiredMark={false}
      onFinish={handleSubmitForm}
    >
      <Form.Item
        label={null}
        name="email"
        rules={[
          { type: "email", message: "Invalid email!" },
        ]}
      >
        <Input
          type="email"
          placeholder="Please input email"
          style={{
            width: 'calc(100% + 17px)',
          }}
        />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Subscribe
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SubscribeForm;
